import React from "react";
import { Button } from "@mui/material";

const ModeHeader = ({ title, onBack, right }) => {
  return (
    <div className="flex items-center justify-between">
      <div className="flex items-center gap-3">
        {onBack && (
          <Button variant="outlined" onClick={onBack}>
            ←
          </Button>
        )}
        <h1 className="text-3xl font-semibold">{title}</h1>
      </div>
      <div>{right}</div>
    </div>
  );
};

export default ModeHeader;
